<template>
  <aside class="menu app-sidebar animated" v-if="logged && user && menu.length > 0">
    <ul class="menu-list">
      <li v-for="item in menu">
        <template v-if="item.meta.redirect && parseInt(user.level) === 99">
          <a :to="item.path" :exact="true" @click="redirect()">
            <span class="icon is-small"><i :class="['fa', item.meta.icon]"></i></span>
             {{ item.meta.label }}
          </a>
        </template>
        <template v-else>
          <!--<router-link :to="item.path" :exact="true" :aria-expanded="isExpanded(item) ? 'true' : 'false'" v-if="item.path" @click.native="toggle(item)">-->
          <!--<span class="icon is-small"><i :class="['fa', item.meta.icon]"></i></span>-->
          <!--{{ item.meta.label || item.name }}-->
          <!--<span class="icon is-small is-angle" v-if="item.children && item.children.length">-->
          <!--<i class="fa fa-angle-down"></i>-->
          <!--</span>-->
          <!--</router-link>-->
          <a :aria-expanded="isExpanded(item)" @click="toggle(item)">
            <span class="icon is-small"><i :class="['fa', item.meta.icon]"></i></span>
            {{ item.meta.label || item.label }}
            <span class="icon is-small is-angle" v-if="item.children && item.children.length">
            <i class="fa fa-angle-down"></i>
          </span>
          </a>
          <expanding v-if="item.children && item.children.length">
            <ul v-show="isExpanded(item)">
              <li v-for="subItem in item.children">
                <router-link :to="generatePath(item, subItem)">
                  {{ subItem.meta.label || subItem.label }} <span class="tag is-warning is-small is-pulled-right" :id="subItem.meta.id" v-if="subItem.meta.counter">0</span>
                </router-link>
              </li>
            </ul>
          </expanding>
        </template>
      </li>
    </ul>
  </aside>
</template>

<script>
  import Expanding from 'vue-bulma-expanding'
  export default {
    components: {
      Expanding
    },

    props: {
      show: Boolean
    },

    data () {
      return {
        isReady: false,
        menu: []
      }
    },

    mounted () {
      if (this.user) {
        this.$http.get(this.$store.state.config.apiURL + '/menu/user').then((response) => {
          let menu = response.body
          if (parseInt(this.user.agency_id) === 968 || parseInt(this.user.agency_id) === 993) {
            menu.splice(8, 1)
            menu.splice(0, 1)
          }
          menu.forEach(itens => {
            if (itens.type === 1) {
              this.menu.push(
                {
                  id: itens.id,
                  meta: {
                    label: itens.name,
                    icon: itens.icon,
                    expanded: parseInt(itens.expanded) === 1,
                    redirect: parseInt(itens.redirect) === 1
                  },
                  children: [
                  ]
                }
              )
            }
          })
          menu.forEach(itensSub => {
            if (itensSub.type === 2) {
              this.menu.forEach(itens => {
                if (itensSub.menu_id === itens.id) {
                  itens.children.push(
                    {
                      label: itensSub.name,
                      path: itensSub.path,
                      meta: {
                        view: itensSub.view,
                        counter: parseInt(itensSub.view) === 1
                      }
                    }
                  )
                }
              })
            }
          })
        }, (response) => {
        })
      }
      let route = this.$route
      if (route.name) {
        this.isReady = true
        this.shouldExpandMatchItem(route)
      }

      if (this.$store.state.config.logged) {
        // this.$options.sockets['counter-user-' + this.$store.state.config.user.id] = (data) => {
        //   this.$store.dispatch('SET_COUNTERS', data)
        //   this.setCounters(this.$store.state.config.counters)
        // }
        // this.get_counters()
      }
      // if (this.$store.state.config.counters) {
      //   this.setCounters(this.$store.state.config.counters)
      // }
    },

    computed: {

      user () {
        if (this.$store.state.config.user) {
          return this.$store.state.config.user
        } else {
          return null
        }
      },
      logged () {
        return this.$store.state.config.logged
      }
    },

    methods: {
      // get_counters () {
      //   let socket = this.$socket
      //   let store = this.$store.state.config
      //   let func = this
      //   setTimeout(function () {
      //     socket.emit('get_counters', {'user': store.user.id})
      //     func.get_counters()
      //   }, 300000)
      // },
      isExpanded (item) {
        return item.meta.expanded
      },
      toggle (item) {
        item.meta.expanded = !item.meta.expanded
      },
      shouldExpandMatchItem (route) {
        let matched = route.matched
        let lastMatched = matched[matched.length - 1]
        let parent = lastMatched.parent || lastMatched
        if (parent === lastMatched) {
          const p = this.findParentFromMenu(route)
          if (p) {
            parent = p
          }
        }
        if ('expanded' in parent.meta && parent !== lastMatched) {
          parent.meta.expanded = true
        }
      },
      generatePath (item, subItem) {
        return `${item.component ? item.path + '/' : ''}${subItem.path}`
      },
      findParentFromMenu (route) {
        const menu = this.menu
        for (let i = 0, l = menu.length; i < l; i++) {
          const item = menu[i]
          const k = item.children && item.children.length
          if (k) {
            for (let j = 0; j < k; j++) {
              if (item.children[j].name === route.name) {
                return item
              }
            }
          }
        }
      },
      setCounters (counters) {
        if (window.document.querySelector('#service-queue')) {
          window.document.querySelector('#service-queue').innerHTML = counters.service_queue
        }
        if (window.document.querySelector('#service-pending')) {
          window.document.querySelector('#service-pending').innerHTML = counters.service_pending
        }
        if (window.document.querySelector('#occurrence-internal-queue')) {
          window.document.querySelector('#occurrence-internal-queue').innerHTML = counters.occurrence_internal_queue
        }
        if (window.document.querySelector('#occurrence-internal-pending')) {
          window.document.querySelector('#occurrence-internal-pending').innerHTML = counters.occurrence_internal_pending
        }
        if (window.document.querySelector('#occurrence-queue')) {
          window.document.querySelector('#occurrence-queue').innerHTML = counters.occurrence_queue
        }
        if (window.document.querySelector('#occurrence-pending')) {
          window.document.querySelector('#occurrence-pending').innerHTML = counters.occurrence_pending
        }
        if (window.document.querySelector('#occurrence-client')) {
          window.document.querySelector('#occurrence-client').innerHTML = counters.occurrence_client
        }
        if (window.document.querySelector('#occurrence-generic')) {
          window.document.querySelector('#occurrence-generic').innerHTML = counters.occurrence_generic
        }
      },
      redirect () {
        // this.$http.post(this.$store.state.config.apiURL + '/users/token').then((response) => {
        window.open('https://book.ezconnect.link', '_blank')
        // }, (response) => {
        // })
      }
    },
    watch: {
      $route (route) {
        this.isReady = true
        this.shouldExpandMatchItem(route)
      }
    }

  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .app-sidebar {
    position: fixed;
    top: 50px;
    left: 0;
    bottom: 0;
    padding: 20px 0 50px;
    width: 215px;
    min-width: 45px;
    max-height: 100vh;
    height: calc(100% - 50px);
    z-index: 1024 -1;
    background: #FFF;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    overflow-y: auto;
    overflow-x: hidden;

  @include mobile() {
    transform: translate3d(-180px, 0, 0);
  }

  .icon {
    vertical-align: baseline;

  &
  .is-angle {
    position: absolute;
    right: 10px;
    transition: transform .377s ease;
  }

  }

  .menu-label {
    padding-left: 5px;
  }

  .menu-list {

  li a {

  &
  [aria-expanded="true"] {

  .is-angle {
    transform: rotate(180deg);
  }

  }
  }

  li a + ul {
    margin: 0 10px 0 15px;
  }

  }

  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?b331199c